import { Component, ElementRef, inject, input, output, signal, ViewChild } from '@angular/core';
import { NgbModalService } from '@zayan-erp/shared';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SvgIconsComponent } from '../../../../../../libs/shared/src/lib/components/svg-icons/svg-icons.component';
import { InputFieldComponent } from '@zayan-erp/shared';
import { FormsModule } from '@angular/forms';
import { ProjectsService } from '../../services/projects.service';
import { Elevation } from '../../models/elevation.models';

@Component({
  selector: 'lib-model-card',
  imports: [SvgIconsComponent, InputFieldComponent, FormsModule],
  templateUrl: './model-card.component.html',
  styleUrl: './model-card.component.scss'
})
export class ModelCardComponent {
  model = input<any>();
  edit = signal<boolean>(false);
  @ViewChild('viewElevationModal') viewElevationModal!: ElementRef;
  removeModel = output<string>();
  updateModelElevation = output<any>();
  #ngbModelService = inject(NgbModalService);
  #modalService = inject(NgbModal);
  #projectsService = inject(ProjectsService);
  projectId = input<string | null>();
  elevationAmounts: { [key: string]: number } = {};

  viewElevations() {
    this.#modalService.open(this.viewElevationModal, { ...this.#ngbModelService.centerModal, size: 'xl' });
  }

  remove() {
    this.removeModel.emit(this.model()?.id.toString());
  }

  editModel() {
    this.edit.set(true);
    this.elevationAmounts = {};
    this.model()?.elevations?.forEach((elevation: any) => {
      this.elevationAmounts[elevation.elevationId] = elevation.amount;
    });
    this.#modalService.open(this.viewElevationModal, { ...this.#ngbModelService.centerModal, size: 'xl' });
  }

  updateElevations() {
    const modelElevation: Elevation[] = this.model()?.elevations.map((elevation: any) => ({
      elevationId: elevation.elevationId,
      amount: this.elevationAmounts[elevation.elevationId] || elevation.amount
    }));

    const updatedModel = {
      modelId: this.model()?.id,
      elevations: modelElevation
    };
    this.updateModelElevation.emit(updatedModel);
    this.edit.set(false);
    this.#modalService.dismissAll();
  }

  closeModal() {
    this.edit.set(false);
    this.#modalService.dismissAll();
  }
}
